import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import RouteList from './route-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Routes">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Routes</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <RouteList />
    </Panel>
  );
};

export default Page;
